/**
 * The react-widgets date localizer, using dayjs in London time. A port of
 * react-widgets-moment, which needed moment: same formats, same strict
 * parsing. react-widgets v4 has no dayjs localizer of its own.
 */
// @ts-expect-error react-widgets v4 has no types for its configure module
import configure from 'react-widgets/lib/configure'

import { dayjsLondon, dayjsUtc, firstDayOfWeek } from 'lib/dayjs'

type FormatFn = (
  date: Date,
  culture: string | undefined,
  localizer: { format: (value: Date, format: string) => string }
) => string

const endOf = (date: Date, years: number) =>
  dayjsUtc(date).add(years, 'year').subtract(1, 'millisecond').toDate()

const yearRange =
  (years: number): FormatFn =>
  (date, _culture, localizer) =>
    `${localizer.format(date, 'YYYY')} - ${localizer.format(
      endOf(date, years),
      'YYYY'
    )}`

export const dayjsLocalizer = {
  formats: {
    date: 'L',
    time: 'LT',
    default: 'lll',
    header: 'MMMM YYYY',
    footer: 'LL',
    weekday: 'dd',
    dayOfMonth: 'DD',
    month: 'MMM',
    year: 'YYYY',
    decade: yearRange(10),
    century: yearRange(100),
  },
  firstOfWeek: () => firstDayOfWeek(),
  parse: (value: string, format: string): Date | null => {
    if (!value) return null
    const date = dayjsLondon(value, format, true)
    return date.isValid() ? date.toDate() : null
  },
  format: (value: Date, format: string): string =>
    dayjsLondon(value).format(format),
}

/** Tells react-widgets to use dayjs for its date pickers */
export const setDayjsDatePickerLocalizer = () => {
  configure.setDateLocalizer(dayjsLocalizer)
}
